// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2IQM48HzrmeEK9_4P4H0-1 {\n  width: calc(100% - 60px);\n  height: 100%;\n  object-fit: contain;\n  object-position: top;\n  margin: 30px;\n}\n", "",{"version":3,"sources":["webpack://src/components/DocumentViewer/SimpleImageViewer.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd","sourcesContent":[".image {\n  width: calc(100% - 60px);\n  height: 100%;\n  object-fit: contain;\n  object-position: top;\n  margin: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": "_2IQM48HzrmeEK9_4P4H0-1"
};
export default ___CSS_LOADER_EXPORT___;
